<template>
  <nav-bar
    title="钢瓶"
    :hasBack="stId !== $store.state.roleInfo.companyId"
    :back="goBack"
  />
  <layout-supervise :top="48">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading(stId)"
    />
    <div class="total-info">
      <span>区域名称：{{ objData.stName }}</span>
      <span>用户钢瓶总数：{{ objData.allNum }}</span>
    </div>
    <ul class="list">
      <li class="list-item" v-for="item in list" :key="item.regionCode">
        <span>{{ item.regionName }}:</span>
        <span
          class="item-link"
          :style="{ 'text-decoration': item.reNum > 0 ? 'underline' : '' }"
          @click="handleNumClick(item)"
        >
          {{ item.reNum }}
        </span>
      </li>
    </ul>
  </layout-supervise>
</template>

<script>
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { StatisticsCylinderByRegion } from '@/api/superviseHome'
import { useStore } from 'vuex'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
export default {
  name: 'SupervisionCylinder',
  setup() {
    const objData = ref({})
    const list = ref([])
    const store = useStore()
    const stId = ref('')
    const companyId = computed(() => store.state.roleInfo.companyId)
    stId.value = companyId.value
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      StatisticsCylinderByRegion,
      data => {
        objData.value = data
        list.value = data.infoList
      }
    )
    getDataLoading(stId.value)
    const router = useRouter()
    const handleNumClick = ({ level, regionCode, regionName }) => {
      if (level < 4) {
        stId.value = regionCode
        getDataLoading(stId.value)
      } else {
        router.push(`/supervisionCylinderList/${regionName}/${regionCode}`)
      }
    }
    const goBack = () => {
      stId.value = companyId.value
      getDataLoading(stId.value)
    }
    return {
      getDataLoading,
      showLoading,
      isLoading,
      objData,
      list,
      stId,
      handleNumClick,
      goBack
    }
  }
}
</script>

<style lang="scss" scoped>
.total-info {
  padding: 16px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
}
.list {
  padding: 0 16px;
  .list-item {
    background: #fff;
    font-size: 16px;
    padding: 10px 5px;
    margin-bottom: 10px;
    .item-link {
      color: blue;
      padding-left: 10px;
    }
  }
}
</style>
